export const PHONE = "(615) 987-0139";
export const PHONE_TEL = "tel:+16159870139";
export const EMAIL = "Zach.Alexander@RedeemerSolutionsLLC.com";
export const EMAIL_MAILTO = "mailto:Zach.Alexander@RedeemerSolutionsLLC.com";
export const ADDRESS = "3050 Ronstadt Dr, Christiana, TN 37037, USA";
export const HOURS_WEEK = "Monday – Friday";
export const HOURS_TIME = "7:00 AM – 4:30 PM";
export const AFTER_HOURS = "After-hours & weekend emergency dispatch available";
export const SLOGAN = "There's always a solution.";

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/about", label: "About Us", testid: "nav-about-link" },
  { to: "/why-choose-us", label: "Why Choose Us", testid: "nav-why-us-link" },
  { to: "/services", label: "Services", testid: "nav-services-link" },
  { to: "/maintenance-plans", label: "Maintenance", testid: "nav-maintenance-link" },
  { to: "/gallery", label: "Gallery", testid: "nav-gallery-link" },
  { to: "/testimonials", label: "Testimonials", testid: "nav-testimonials-link" },
  { to: "/prayer-requests", label: "Prayer Requests", testid: "nav-prayer-requests-link" },
  { to: "/blog", label: "Blog", testid: "nav-blog-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export const SERVICES = [
  {
    slug: "security-cameras",
    name: "Security Camera Service & Repair",
    shortName: "Security Cameras",
    icon: "Cctv",
    image: "https://images.unsplash.com/photo-1639242689301-1d51c12f595d?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Professional security camera mounted on a commercial building exterior",
    tagline: "Eyes that never sleep, restored with care.",
    short: "Diagnostics, repair, and maintenance for HD and 4K surveillance systems — keeping churches, schools, businesses, and homes protected across Middle Tennessee.",
    heroLines: ["Watch Over", "What Matters Most"],
    intro: "When a camera goes dark or a recorder stops recording, your protection has a gap. We find the fault fast — camera, cable, power, network, or recorder — and restore full coverage with clean workmanship and honest pricing. And with regular maintenance, small issues never become blind spots.",
    benefits: [
      "Fast diagnostics that find the real fault, not just the symptom",
      "Night vision and image quality restored to full clarity",
      "Remote viewing repaired and re-secured on your phone or computer",
      "Cabling repaired and dressed properly — no messy wires left behind",
      "Recording gaps eliminated so footage is there when you need it",
      "Preventive maintenance that catches failures before they happen",
    ],
    service: [
      "Full system health checks, camera by camera",
      "Lens cleaning, focus, and field-of-view optimization",
      "Recorder (NVR/DVR) service, storage checks, and remote viewing setup",
      "Scheduled maintenance plans for churches, schools, and businesses",
    ],
    repair: [
      "Dead cameras, flickering feeds, and recording gaps diagnosed and fixed",
      "Camera, cable, connector, and power supply replacement",
      "Firmware updates and network troubleshooting",
      "Storm, vandalism, and age-related damage restoration",
    ],
    faqs: [
      { q: "Do you service systems you didn't install?", a: "Absolutely — that's most of what we do. We service and repair most major camera brands, regardless of who put them in." },
      { q: "A camera went dark. How fast can you get here?", a: "Call us. Most service calls are scheduled within one business day, and after-hours emergency dispatch is available when it can't wait." },
      { q: "Can you restore remote viewing on my phone?", a: "Yes. We'll repair the network or recorder issue, re-secure the connection, and test it with you before we leave." },
      { q: "Our night footage is grainy. Can that be fixed?", a: "Usually yes — cleaning, focus adjustment, IR servicing, or a camera swap where it's truly worn out. We'll show you the difference before and after." },
    ],
  },
  {
    slug: "access-control",
    name: "Access Control Service & Repair",
    shortName: "Access Control",
    icon: "Fingerprint",
    image: "https://images.pexels.com/photos/13657444/pexels-photo-13657444.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Electronic access control keypad and card reader on a secure door",
    tagline: "The right people in. Everyone else out.",
    short: "Service and repair for keyless entry, card readers, keypads, and magnetic locks — so your doors open for the right people, every time.",
    heroLines: ["The Right People In.", "Everyone Else Out."],
    intro: "A reader that stops reading or a door that won't latch isn't just an inconvenience — it's an open invitation. We service and repair access control systems of all major brands: restoring reliable entry, reprogramming credentials, and keeping your audit trails intact.",
    benefits: [
      "Doors that latch and lock reliably, every time",
      "Lost-card and former-employee access revoked in minutes",
      "Schedules reprogrammed as your services and hours change",
      "Audit trails restored — who entered, where, and when",
      "Battery backup and power supplies tested and serviced",
      "One call for readers, strikes, mag locks, and controllers",
    ],
    service: [
      "System health checks and door-by-door testing",
      "Credential database cleanup and reprogramming",
      "Unlock schedule updates for services, school hours, and events",
      "Battery backup and power supply testing and replacement",
    ],
    repair: [
      "Card reader, keypad, and entry station troubleshooting",
      "Electric strike and magnetic lock repair and replacement",
      "Door alignment and hardware adjustment for reliable latching",
      "Controller and communication fault diagnosis",
    ],
    faqs: [
      { q: "Our door won't latch properly. Is that an access control problem?", a: "Often it's door hardware or alignment, not the electronics. We service both, so one visit fixes the whole problem." },
      { q: "A former employee still has a card. Can you help?", a: "Yes — we'll revoke old credentials, audit the database, and make sure only current staff have access." },
      { q: "Do you service systems installed by another company?", a: "Yes. We work on most major access control brands and will give you an honest assessment of what needs attention." },
      { q: "What happens if the power goes out?", a: "We'll test your battery backup and verify fail-safe or fail-secure behavior per door, based on fire code and your safety needs." },
    ],
  },
  {
    slug: "fiber-optics",
    name: "Fiber Optics Service & Repair",
    shortName: "Fiber Optics",
    icon: "Cable",
    image: "https://images.unsplash.com/photo-1604869515882-4d10fa4b0492?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Glowing fiber optic strands carrying pulses of light",
    tagline: "Light-speed backbone, restored fast.",
    short: "Fiber testing, troubleshooting, and emergency splice repair — restoring the high-speed backbone your cameras, network, and phones depend on.",
    heroLines: ["Light-Speed Backbone", "Restored Fast"],
    intro: "When a fiber link goes down, everything it carries goes with it — cameras, phones, network, access control. We locate the fault with OTDR precision, fusion-splice the repair, and certify the link with documented test results before we call it done.",
    benefits: [
      "OTDR fault location — we find the break without digging blind",
      "Fusion splicing for near-zero signal loss at every repair",
      "Documented test results you can hand to any IT team",
      "Emergency dispatch when a cut line takes you down",
      "Clean, labeled, serviceable terminations left behind",
      "Honest advice on repair versus replacement",
    ],
    service: [
      "OTDR and power-meter testing with printed certification",
      "Link audits and documentation of existing fiber plant",
      "Connector cleaning and end-face inspection",
      "Preventive inspection of enclosures, trays, and patch panels",
    ],
    repair: [
      "Locate and fusion-splice cut or damaged fiber spans",
      "Re-terminate failed or dirty connectors",
      "Replace damaged enclosures and patch panels",
      "Emergency restoration for downed critical links",
    ],
    faqs: [
      { q: "A contractor cut our fiber line. Can you fix it?", a: "Yes — call us. We locate the break with an OTDR, fusion-splice the repair, and re-test the link to certify it's back to spec." },
      { q: "The link between our buildings went down. Where do you start?", a: "We test from both ends to locate the fault, then repair the damaged section — whether it's in the ground, in a conduit, or in a closet." },
      { q: "We don't know what fiber we have. Can you identify it?", a: "Yes. We identify single-mode versus multi-mode, map your links, and leave you with documentation of what you own." },
      { q: "Do you provide test documentation?", a: "Every link we repair is OTDR or power-meter tested, and you receive the results for your records." },
    ],
  },
  {
    slug: "ethernet",
    name: "Ethernet & Data Cabling Services",
    shortName: "Ethernet Services",
    icon: "Network",
    image: "https://images.unsplash.com/photo-1698668975271-2ba9a323be6b?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Neatly dressed Ethernet cabling in a professional network rack",
    tagline: "Order restored to your network.",
    short: "Structured cabling service, testing, and cleanup — tracing dead drops, taming network closets, and certifying the cabling you already own.",
    heroLines: ["Structured Cabling,", "Brought Back to Order"],
    intro: "Messy, untested cabling costs you every time something changes or fails. We trace, test, label, and document your existing copper network — and repair the dead drops, failed jacks, and tangled closets that slow your whole operation down.",
    benefits: [
      "Dead and intermittent drops traced and repaired",
      "Every run tested and certified to spec, not just plugged in",
      "Labeled, documented ports — no more mystery cables",
      "Network closets dressed and organized for easy service",
      "PoE issues diagnosed for cameras, phones, and access points",
      "Faster troubleshooting when every run is mapped",
    ],
    service: [
      "Cable tracing, toning, and full network mapping",
      "Testing and certification of existing Cat5e/Cat6/Cat6A runs",
      "Labeling, documentation, and port mapping",
      "Network closet cleanup, re-dressing, and organization",
    ],
    repair: [
      "Dead or intermittent network drop diagnosis and repair",
      "Re-termination of failed jacks and patch panel ports",
      "Replacement of damaged cable runs",
      "PoE fault-finding for cameras, phones, and wireless access points",
    ],
    faqs: [
      { q: "Half our drops are dead and nobody knows where they go. Can you help?", a: "That's one of our most common calls. We tone and trace every run, repair what's failed, and leave you with a labeled map." },
      { q: "Can you clean up our network closet?", a: "Yes — closet rescues are some of our most satisfying work. We trace, label, re-dress, and document everything." },
      { q: "Our cameras keep dropping offline. Is that cabling?", a: "Often it's a PoE or termination issue. We test the full path — switch, cable, and device — and fix the real cause." },
      { q: "Do you certify existing cabling?", a: "Yes. We test to Cat5e/Cat6/Cat6A standards and document the results so you know exactly what your network can handle." },
    ],
  },
  {
    slug: "video-intercom",
    name: "Video Intercom Service & Repair",
    shortName: "Video Intercom",
    icon: "BellRing",
    image: "https://images.unsplash.com/photo-1581431019684-bfd38511b924?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Modern video intercom entry station at a building entrance",
    tagline: "See who's at the door before it opens.",
    short: "Service and repair for video intercom and door entry systems — restoring the ability to see, speak, and buzz in visitors with confidence.",
    heroLines: ["See Who's There,", "Before the Door Opens"],
    intro: "When the intercom goes silent or the video feed drops, your front-door protocol falls apart. We diagnose and repair video, audio, and door-release faults — and bring older buzzer systems up to modern standards where parts allow.",
    benefits: [
      "Video and audio restored at every entry station",
      "Door release working reliably from desk or phone",
      "Mobile app calling repaired and reconfigured",
      "Integration with existing access control maintained",
      "Front-office entry protocol back to smooth and secure",
      "Honest guidance when a legacy system is worth upgrading",
    ],
    service: [
      "Full system testing: video, audio, and door release",
      "Master station and mobile app reconfiguration",
      "Call routing updates for staff and schedule changes",
      "Preventive maintenance and entry-station cleaning",
    ],
    repair: [
      "No-video, no-audio, and door-release failure diagnosis",
      "Entry station, camera module, and screen replacement",
      "Network and PoE troubleshooting for IP intercoms",
      "Legacy audio-only system assessment and upgrade paths",
    ],
    faqs: [
      { q: "The office can't buzz visitors in anymore. Can you fix that?", a: "Yes — door-release faults are usually a strike, wiring, or station issue. We diagnose the full chain and restore reliable release." },
      { q: "Our intercom video is dead but audio works. What's wrong?", a: "Typically the camera module or its cabling. We test both and repair or replace the failed component." },
      { q: "Can calls ring to a cell phone after hours?", a: "If your system supports it, we'll configure mobile calling so authorized staff can see and admit visitors from anywhere." },
      { q: "We have an old buzzer system. Is it worth repairing?", a: "We'll assess it honestly — many can be kept going, and when replacement makes more sense, we'll tell you that too." },
    ],
  },
];

export const COMPARE_PAIRS = [
  {
    id: "cabinet",
    title: "Network Cabinet Clean-Up",
    location: "Calvary Baptist Church — Shelbyville, TN",
    before: "/gallery/cabinet-before.webp",
    after: "/gallery/cabinet-after.webp",
  },
  {
    id: "data-wall",
    title: "Data Wall Clean-Up",
    location: "Calvary Baptist Church — Shelbyville, TN",
    before: "/gallery/wall-before.webp",
    after: "/gallery/wall-after.webp",
  },
];

export const GALLERY = [
  { url: "https://images.pexels.com/photos/9301020/pexels-photo-9301020.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", title: "Commercial CCTV Camera Service Call", category: "Security Cameras" },
  { url: "https://images.pexels.com/photos/1990764/pexels-photo-1990764.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", title: "Access Control Keypad Repair", category: "Access Control" },
  { url: "https://images.unsplash.com/photo-1604869515882-4d10fa4b0492?crop=entropy&cs=srgb&fm=jpg&q=85", title: "Fiber Backbone Splice Restoration", category: "Fiber Optics" },
  { url: "https://images.pexels.com/photos/4486718/pexels-photo-4486718.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", title: "Server Rack Cabling Cleanup", category: "Ethernet Services" },
  { url: "https://images.unsplash.com/photo-1774876549476-254b00a5d648?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", title: "Sleek Video Intercom Door Station Service", category: "Video Intercom" },
  { url: "https://images.unsplash.com/photo-1694174439282-ee8cdf0ec6ba?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", title: "Entry Intercom Panel Service", category: "Video Intercom" },
  { url: "https://images.unsplash.com/photo-1585206031650-9e9a7c87dcfe?crop=entropy&cs=srgb&fm=jpg&q=85", title: "Sanctuary Security System Tune-Up", category: "Church & School Security" },
];

export const TESTIMONIALS = [
  { name: "Pastor Daniel R.", org: "Grace Fellowship Church — Murfreesboro, TN", service: "Security Cameras & Access Control", quote: "Zach walked our entire campus and found problems we never knew existed. The service has given our congregation real peace of mind, and the work was clean, on time, and honest." },
  { name: "Melissa T.", org: "Private School Administrator — Shelbyville, TN", service: "Video Intercom & Access Control", quote: "Our front office can now see and speak with every visitor before the door opens. Redeemer Solutions treated our school's safety like it was their own family's." },
  { name: "James W.", org: "Facility Manager — Smyrna, TN", service: "Fiber Optics Repair", quote: "A cut fiber line took down two of our buildings on a Friday afternoon. Zach came out after hours and had us certified and back online that evening." },
  { name: "Karen H.", org: "Business Owner — Christiana, TN", service: "Ethernet Cabling", quote: "Our network closet went from a rat's nest to something out of a magazine. Every cable labeled, every port tested. Professional from the first call to the final walkthrough." },
  { name: "Chief Michael B.", org: "Emergency Services Facility — Rutherford County, TN", service: "Camera System Service", quote: "They understood the urgency of a facility that can never be down. The after-hours availability isn't a slogan — they proved it to us twice." },
  { name: "Sarah L.", org: "Children's Ministry Director — Rockvale, TN", service: "Access Control", quote: "Knowing only authorized volunteers can enter our children's wing lets parents drop off with confidence. Redeemer keeps the system maintained so it never lets us down." },
];

export const HERO_BG = "https://images.unsplash.com/photo-1563920443079-783e5c786b83?crop=entropy&cs=srgb&fm=jpg&q=85";
export const HEADER_SUNSET = "https://images.pexels.com/photos/19063120/pexels-photo-19063120.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1600";
export const FACEBOOK_URL = "https://www.facebook.com/share/19xsfKSv4w/?mibextid=wwXIfr";
export const LINKEDIN_URL = "https://www.linkedin.com/company/redeemer-solutions-llc./";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CURMt6sAJWzVEBM/review";

export const MARQUEE_ITEMS = [
  "Security Camera Service",
  "Access Control Repair",
  "Fiber Optics",
  "Ethernet & Data Cabling",
  "Video Intercom",
  "24/7 Emergency Service",
  "ISNetworld Member Contractor",
  "There's Always a Solution.",
];
